import { Report, ReportType } from '@/api/generatedApi';
import { Box, Typography } from '@mui/material';
import { ThresholdRangeDetail } from './details/ThresholdRangeDetail';
import { SearchQueryDetail } from './details/SearchQueryDetail';
import { FolderPathsDetail } from './details/FolderPathsDetail';
import { MetadataFiltersDetail } from './details/MetadataFiltersDetail';
import { FileExtensionsDetail } from './details/FileExtensionsDetail';

export const ReportDetailsCell = ({ report }: { report: Report }) => {
  const hasSearchQuery = report.searchQuery && report.searchQuery.trim() !== '';
  const hasFolderPaths = report.folderPaths && report.folderPaths.length > 0;
  const hasMetadataFilters = report.metadataFilters && Object.keys(report.metadataFilters).length > 0;
  const hasExtensions = report.extensions && report.extensions.length > 0;
  const showThresholds = report.reportType === ReportType.CUSTOM;
  const hasAnyFilters = hasSearchQuery || hasFolderPaths || hasMetadataFilters || hasExtensions;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '12px',
        padding: '4px 0',
        width: '100%',
        flexWrap: 'wrap',
      }}
    >
      {showThresholds && <ThresholdRangeDetail minThreshold={report.minThreshold} maxThreshold={report.maxThreshold} />}
      {hasSearchQuery && <SearchQueryDetail searchQuery={report.searchQuery} />}
      {hasFolderPaths && <FolderPathsDetail folderPaths={report.folderPaths} />}
      {hasMetadataFilters && <MetadataFiltersDetail metadataFilters={report.metadataFilters} />}
      {hasExtensions && <FileExtensionsDetail extensions={report.extensions} />}
      {!hasAnyFilters && report.reportType !== ReportType.CUSTOM && (
        <Typography sx={{ fontSize: '0.813rem', color: 'text.secondary', whiteSpace: 'nowrap' }}>All Assets</Typography>
      )}
    </Box>
  );
};
